import request from '../utils/request';

export function getFAQs(params) {
  return request({
    url: '/api/faq/question/',
    method: 'get',
    params
  })
}

export function createQuestion(data) {
  return request({
    url: '/api/faq/question/',
    method: 'post',
    data
  })
}

export function updateQuestion(data) {
  return request({
    url: `/api/faq/question/${data.id}/`,
    method: 'patch',
    data
  })
}

export function updateApi({data, id}) {
  return request({
    url: `/api/alerts/integration_api/${id}/`,
    method: 'patch',
    data
  })
}


export function deleteQuestion(id) {
  return request({
    url: `/api/faq/question/${id}/`,
    method: 'delete',
  })
}


// answer
export function getAnswers(params) {
  return request({
    url: `/api/faq/question/${params.id}/`,
    method: 'get',
  })
}

export function createAnswer(data) {
  return request({
    url: '/api/faq/answer/',
    method: 'post',
    data
  })
}

export function updateAnswer(data) {
  return request({
    url: `/api/faq/answer/${data.id}/`,
    method: 'patch',
    data
  })
}


export function deleteAnswer(id) {
  return request({
    url: `/api/faq/answer/${id}/`,
    method: 'delete',
  })
}

// alerts
export function getAlerts(params) {
  return request({
    url: `/api/alerts/integration_api/`,
    method: 'get',
    params
  })
}
